var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 19L15.5625 12L19.0625 15.5M8.125 19H16.875C18.3247 19 19.5 17.8247 19.5 16.375V12M8.125 19C6.67525 19 5.5 17.8247 5.5 16.375V7.625C5.5 6.17525 6.67525 5 8.125 5H13.8125M16 6.78104L17.7896 5M17.7896 5L19.5 6.70054M17.7896 5V9.375M10.75 8.9375C10.75 9.66237 10.1624 10.25 9.4375 10.25C8.71263 10.25 8.125 9.66237 8.125 8.9375C8.125 8.21263 8.71263 7.625 9.4375 7.625C10.1624 7.625 10.75 8.21263 10.75 8.9375Z",
    stroke: "#00123A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitPhoto);
export default __webpack_public_path__ + "static/media/SubmitPhoto.8d3e6de207abf584c495f760d7cc4388.svg";
export { ForwardRef as ReactComponent };